<template>
  <div :class="{'animationComplete' : animationComplete}">
    <BackgroundFader class="blurable" ref="bgFader" :content="images" @complete="animationComplete = true;"/>
    <FullScreenVideo class="reveal blurable" src="video/2-4.mp4" />
    <BackgroundFader class="blurable alertBox" ref="bgFader2" :content="images2"/>
    
    <PageWrapper class="blurable">

      <InfoBlock :subTitle="gd[currentScenario].subTitle" :title="gd[currentScenario].title" :content="gd[currentScenario].steps[currentStep]"/>

      <Button btnContent="Replay animation" iconType="replay" @click="replay" class="replayButton reveal" />
      
      <Button class="scenarioNextButton" btnContent="Next step" iconType="arrow" @click="$router.push('step3')"/>
      <Button class="scenarioPreviousButton" iconType="arrow" @click="$router.push('step1')"/>
      <Button btnContent="Gallery" @click="openGallery" class="galleryButton" />
    
    </PageWrapper>

    <HotspotsWrapper class="blurable reveal">
      <Hotspot x="940" y="80" @click="openModel('modelWindow1')"/>
      <Hotspot x="940" y="400" @click="openModel('modelWindow2')"/>
    </HotspotsWrapper>

    <ModelWindow ref="modelWindow1">
      <h1>Control centre</h1>
      <p>The control centre receives signals from the MAD system in the truck, indicating toxic gas. Here, operators can coordinate the necessary sampling and decontamination response.</p>
    </ModelWindow>

    <ModelWindow ref="modelWindow2">
      <h1>Command Area Detection (CAD)</h1>
      <p>The CAD system provides real-time situational awareness and sensor information to users on one or several screens. Its technologies collect, locate, identify, report, analyse and disseminate data about CBRN and TIM threats and hazards to all relevant authorities and decision-makers.</p>
      <p>Sensor readings are integrated with additional information such as emergency response and medical handbooks, to provide as much detail as possible to the responders.</p>
      <p>CAD gives CBRN specialists and decision-makers support for fast and accurate decisions, which is a key factor in limiting the effects of CBRN threats.</p>
      <p>The system is modular and highly flexible and can be extended and integrated with new modules and sensors. It can collect data from:</p>
      <ul>
        <li>Stationary nodes</li>
        <li>Mobile nodes</li>
        <ul>
          <li>Vehicles </li>
          <li>Deployable</li>
          <li>Personnel</li>
          <li>Simulations</li>
        </ul>
        <li>Predictions</li>
        <li>Simulations</li>
      </ul>

    </ModelWindow>

    <GalleryModal ref="galleryModal" :content="galleryImages"/>
  </div>
</template>


<script>
import PageWrapper from '@/components/PageWrapper';
import InfoBlock from '@/components/InfoBlock';
import AutoStep from '@/components/AutoStep';
import Button from '@/components/Button';
import ModelWindow from "@/components/ModelWindow";
import HotspotsWrapper from '@/components/HotspotsWrapper';
import Hotspot from '@/components/Hotspot';
import BackgroundFader from "@/components/BackgroundFader";
import gd from "@/assets/stores/globalDS.js";
import FullScreenVideo from '@/components/FullScreenVideo';
import GalleryModal from '@/components/paul/GalleryModal';

export default {
  components: {
    PageWrapper,
    InfoBlock,
    AutoStep,
    Button,
    ModelWindow,
    HotspotsWrapper,
    Hotspot,
    BackgroundFader,
    FullScreenVideo,
    GalleryModal
  },
  data() {
    return {
      gd: gd,
      animationComplete: false,
      images: [
        'military/2-1.jpg',
        'military/2-2.jpg',
        'military/2-3.jpg',
        'military/2-3.jpg'
      ],
      images2: [
        'military/empty.png',
        'military/empty.png',
        'military/empty.png',
        'military/2-5.png'
      ],
      galleryImages: gd.gallery.military
    }
  },
  computed: {
    appPath() {
      return this.$router.currentRoute.fullPath.split("/");
    },
    currentStep() {
      return this.appPath[this.appPath.length - 1];
    },
    currentScenario() {
      return this.appPath[this.appPath.length - 2];
    }
  },
  methods: {
    replay() {
      this.animationComplete = false;
      this.$refs.bgFader.reset();
    },
    openModel: function(modelWindow) {
      this.$refs[modelWindow].openModel();
    },
    openGallery: function() {
      this.$refs.galleryModal.openModal();
    }
  }
}
</script>

